import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import {formatTelefone} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class DetalhamentoContato extends Component {

    static propTypes = {
    };

    constructor(props) {
        super(props);
    }

    render() {
        const contatoETT = _.get(this.props.controller, "solicitacaoEtt.contatoEtt");
        const contatoGlobo = _.get(this.props.controller, "solicitacao.contatoGlobo", {nome: "", email: "", telefone: ""});
        const contatoEttEditavel = this.props.controller.contatoEttEditavel;
        const exibeContatoEtt = this.props.controller.exibeContatoEtt;
        const desabilitarValidacao = _.get(this.props, "desabilitarValidacao", false);

        return (
            <div>
                <h4>Contato</h4>
                <Row>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>Contato Globo</Label>
                            <Input type="text" value={contatoGlobo ? contatoGlobo.nome : ""} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>Telefone de contato</Label>
                            <NumberFormat className="form-control"
                                          format={(value) => formatTelefone(value)}
                                          maxLength={15}
                                          value={contatoGlobo ? contatoGlobo.telefone : ""} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>E-mail de contato</Label>
                            <Input type="text" value={contatoGlobo ? contatoGlobo.email : ""} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                {exibeContatoEtt &&
                <Row>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>Contato ETT {contatoEttEditavel && <sup>*</sup>}</Label>
                            <Input type="text" value={contatoETT.nome} onChange={(event) => this.props.controller.setContatoEttNome(event.target.value)} readOnly={!contatoEttEditavel}/>
                            {contatoEttEditavel && !desabilitarValidacao && <Validacao id="contatoETTNome" valor={contatoETT.nome} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>Telefone de contato {contatoEttEditavel && <sup>*</sup>}</Label>
                            <NumberFormat className="form-control"
                                          format={(value) => formatTelefone(value)}
                                          maxLength={15}
                                          value={contatoETT.telefone}
                                          onChange={(event, values) => this.props.controller.setContatoEttTelefone(values.value)}
                                          readOnly={!contatoEttEditavel} />
                            {contatoEttEditavel && !desabilitarValidacao && <Validacao id="contatoETTTelefone" valor={contatoETT.telefone} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>E-mail de contato {contatoEttEditavel && <sup>*</sup>}</Label>
                            <Input type="text" value={contatoETT.email} onChange={(event) => this.props.controller.setContatoEttEmail(event.target.value)} readOnly={!contatoEttEditavel}/>
                            {contatoEttEditavel && !desabilitarValidacao && <Validacao id="contatoETTEmail" valor={contatoETT.email} tipo={["isRequired", "isEmail"]} />}
                        </FormGroup>
                    </Col>
                </Row>
                }
            </div>
        )
    }
}